import { WsSelectObj } from 'wisestep-base';

export const generalTimePeriodList: { label: string; id: string }[] = [
  {
    label: 'Last 1 Hour',
    id: '1H',
  },
  {
    label: 'Last 8 Hours',
    id: '8H',
  },
  {
    label: 'Today',
    id: 'TODAY',
  },
  {
    label: 'Last 24 Hours',
    id: '24H',
  },
  {
    label: 'This Week (Mon - Today)',
    id: 'THIS_WEEK',
  },
  {
    label: 'Last 7 Days',
    id: '7D',
  },
  {
    label: 'Month Till Date',
    id: 'MONTH_TILL_DATE',
  },
  {
    label: 'Last 30 Days',
    id: '30D',
  },
  {
    label: 'Quarter Till Date',
    id: 'CURRENT_QUARTER',
  },
  {
    label: 'Last Quarter',
    id: 'LAST_QUARTER',
  },
  {
    label: 'Year Till Date',
    id: 'YEAR_TILL_DATE',
  },
  {
    label: 'Last Year',
    id: 'LAST_YEAR',
  },
];

export const reducedGeneralTimePeriodList = generalTimePeriodList.filter(
  (time) => !['1H', '8H'].includes(time.id)
);

export const optionsForJobTypeFilter: WsSelectObj[] = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Permanent',
    value: 'Permanent',
  },
  {
    label: 'Contract',
    value: 'Contract',
  },
  {
    label: 'Permanent and Contract',
    value: 'Permanent and Contract',
  },
];
